import { differenceInMinutes } from "date-fns";

export const getShift = (admissionDateTime: string): string => {
  const hour = new Date(admissionDateTime).getHours();
  if (hour >= 6 && hour < 14) return "Morning Shift";
  if (hour >= 14 && hour < 22) return "Evening Shift";
  return "Night Shift";
};

export const isPatientCompliant = (patient: any): boolean => {
  // Patient is compliant if overall progress is 100 or discharge status is "discharged"
  return patient.overall_progress === 100 || patient.discharge_status === "discharged";
};

export const calculateComplianceRate = (compliant: number, total: number): string => {
  if (total === 0) return "0%";
  return `${((compliant / total) * 100).toFixed(1)}%`;
};

export const formatDuration = (minutes: number): string => {
  if (minutes < 60) return `${Math.round(minutes)}m`;
  const hours = Math.floor(minutes / 60);
  const mins = Math.round(minutes % 60);
  if (mins === 0) return `${hours}h`;
  return `${hours}h ${mins}m`;
};

export const calculateElapsedMinutes = (startTime: string): number => {
  return differenceInMinutes(new Date(), new Date(startTime));
};

export const hasTATBreach = (activity: any): boolean => {
  // Activity has TAT breach if status is in yellow/red zone or completed late
  const elapsedTime = activity.elapsed_time;
  if (!elapsedTime) return false;
  
  // Parse elapsed time (format: "HH:MM:SS")
  const parts = elapsedTime.split(':');
  if (parts.length !== 3) return false;
  
  const hours = parseInt(parts[0]);
  const minutes = parseInt(parts[1]);
  const totalMinutes = hours * 60 + minutes;
  
  // Consider breach if over 60 minutes (configurable threshold)
  return totalMinutes > 60;
};

export const getPerformanceRating = (completionRate: number, avgTime: number): string => {
  // Rating based on completion rate and speed
  if (completionRate >= 90 && avgTime < 30) return "5.0";
  if (completionRate >= 80 && avgTime < 45) return "4.5";
  if (completionRate >= 70 && avgTime < 60) return "4.0";
  if (completionRate >= 60) return "3.5";
  return "3.0";
};

export const getEscalationPriority = (patient: any): string => {
  const progress = patient.overall_progress || 0;
  const elapsedTime = patient.elapsed_time || "00:00:00";
  
  // Parse elapsed time
  const parts = elapsedTime.split(':');
  const hours = parseInt(parts[0] || "0");
  
  if (progress < 50 && hours > 24) return "Critical";
  if (progress < 70 && hours > 12) return "High Priority";
  if (progress < 90 && hours > 6) return "Medium Priority";
  return "Low Priority";
};

export const formatElapsedTime = (elapsedTime?: string): string => {
  if (!elapsedTime) return "0m";
  
  const parts = elapsedTime.split(':');
  if (parts.length !== 3) return elapsedTime;
  
  const hours = parseInt(parts[0]) || 0;
  const minutes = parseInt(parts[1]) || 0;
  
  if (hours >= 24) {
    const days = Math.floor(hours / 24);
    const remainingHours = hours % 24;
    if (remainingHours === 0) return `${days}d`;
    return `${days}d ${remainingHours}h`;
  }
  
  if (hours === 0) return `${minutes}m`;
  if (minutes === 0) return `${hours}h`;
  return `${hours}h ${minutes}m`;
};